import theme from 'config/theme';

export default {
  menuList: {
    overflowY: 'auto',
    padding: '24px 16px 6px 16px',
    margin: '0px 0 2px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    height: `calc(100% - ${theme.customValues.sidebar.footerHeight} - ${theme.customValues.topBarHeight})`,
  },
  sectionItemsWrapper: {
    display: 'flex',
    gap: '2px',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    marginBottom: '6px',
  },
  sectionItem: {
    fontSize: '13px',
    fontWeight: 700,
    color: '#1A1A1A',
  },
  sectionIcon: {
    width: 14,
    height: 14,
    color: theme.palette.blues.primaryBlue,
  },
  menuItemWrapper: {
    marginBottom: '6px',
    position: 'relative',
  },
  menuItemIcon: { width: 16, height: 16 },
  noSectionItems: {
    display: 'flex',
    fontSize: '10px',
    fontWeight: 400,
    color: theme.palette.grays.gray600,
  },
  noItemsDummyElement: { width: '20px' },
};
